import DetalheVendas from './DetalheVendas';
import React, { useState, useEffect, useCallback } from 'react';

var API = process.env.REACT_APP_API_URL || '/api';
function rq(path) {
  var token = localStorage.getItem('token');
  return fetch(API + path, { headers: token ? { Authorization: 'Bearer ' + token } : {} }).then(function(r) { return r.json(); });
}

var MESES = ['Janeiro','Fevereiro','Marco','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
var DIAS_SEM = ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'];

export default function DashboardUnificado(props) {
  var setPage = props.setPage;
  var [data, setData] = useState(null);
  var [loading, setLoading] = useState(true);
  var now = new Date();
  var [calMonth, setCalMonth] = useState(now.getMonth());
  var [calYear, setCalYear] = useState(now.getFullYear());
  var [selDay, setSelDay] = useState(null);
  var [periodLabel, setPeriodLabel] = useState('Mes atual');
  var [dateStart, setDateStart] = useState(null);
  var [dateEnd, setDateEnd] = useState(null);
  var [detalheModal, setDetalheModal] = useState(null);

  var loadData = useCallback(function() {
    if (!data) setLoading(true);
    var params = new URLSearchParams();
    if (dateStart) params.set('start', dateStart);
    if (dateEnd) params.set('end', dateEnd);
    rq('/admin/store/dashboard?' + params).then(function(d) { setData(d); setLoading(false); }).catch(function() { setLoading(false); });
  }, [dateStart, dateEnd]);

  useEffect(function() { loadData(); }, [loadData]);

  function setPeriod(label, start, end) {
    setPeriodLabel(label);
    setDateStart(start);
    setDateEnd(end);
    setSelDay(null);
  }

  function fmt(d) { return d.toISOString().slice(0, 10); }

  function selectToday() {
    var t = new Date(); setPeriod('Hoje', fmt(t), fmt(t));
    setCalMonth(t.getMonth()); setCalYear(t.getFullYear());
  }
  function select7d() {
    var t = new Date(); var s = new Date(t); s.setDate(s.getDate() - 6);
    setPeriod('7 dias', fmt(s), fmt(t));
  }
  function select30d() {
    var t = new Date(); var s = new Date(t); s.setDate(s.getDate() - 29);
    setPeriod('30 dias', fmt(s), fmt(t));
  }
  function selectMonth() {
    var s = new Date(calYear, calMonth, 1); var e = new Date(calYear, calMonth + 1, 0);
    setPeriod(MESES[calMonth], fmt(s), fmt(e));
  }

  function prevMonth() {
    var m = calMonth === 0 ? 11 : calMonth - 1;
    var y = calMonth === 0 ? calYear - 1 : calYear;
    setCalMonth(m); setCalYear(y); setSelDay(null);
    var s = new Date(y, m, 1); var e = new Date(y, m + 1, 0);
    setPeriod(MESES[m], fmt(s), fmt(e));
  }
  function nextMonth() {
    var m = calMonth === 11 ? 0 : calMonth + 1;
    var y = calMonth === 11 ? calYear + 1 : calYear;
    setCalMonth(m); setCalYear(y); setSelDay(null);
    var s = new Date(y, m, 1); var e = new Date(y, m + 1, 0);
    setPeriod(MESES[m], fmt(s), fmt(e));
  }

  function clickDay(d) {
    if (selDay === d) {
      setSelDay(null);
      var s2 = new Date(calYear, calMonth, 1); var e2 = new Date(calYear, calMonth + 1, 0);
      setPeriod(MESES[calMonth], fmt(s2), fmt(e2));
    } else {
      setSelDay(d);
      var dt = new Date(calYear, calMonth, d);
      setPeriod(d + ' ' + MESES[calMonth], fmt(dt), fmt(dt));
    }
  }

  var firstDay = new Date(calYear, calMonth, 1).getDay();
  var daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
  var today = new Date();
  function isToday(d) { return d === today.getDate() && calMonth === today.getMonth() && calYear === today.getFullYear(); }
  var calDays = [];
  var i; for (i = 0; i < firstDay; i++) calDays.push(null);
  for (i = 1; i <= daysInMonth; i++) calDays.push(i);

  if (loading) return React.createElement('div', { style: { padding: '2rem', color: 'var(--text-lo)' } }, 'Carregando dashboard...');
  if (!data) return React.createElement('div', { style: { padding: '2rem', color: 'var(--text-lo)' } }, 'Erro ao carregar');

  var k = data.kpis;
  var cal = data.calendar || {};
  var calData = cal.days || {};
  var maxRec = Math.max.apply(null, Object.values(calData).map(function(d) { return d.receita || 0; }).concat([1]));
  var calTotal = Object.values(calData).reduce(function(s, d) { return s + (d.receita || 0); }, 0);
  var topBuyers = data.top_buyers || [];

  function dayColor(rec) {
    if (!rec || rec <= 0) return 'transparent';
    var intensity = Math.min(rec / maxRec, 1);
    if (intensity < 0.25) return 'rgba(37,211,102,0.15)';
    if (intensity < 0.5) return 'rgba(37,211,102,0.3)';
    if (intensity < 0.75) return 'rgba(37,211,102,0.5)';
    return 'rgba(37,211,102,0.7)';
  }

  return React.createElement('div', { style: { padding: '1.5rem', maxWidth: 1100, transition: 'opacity 0.3s', opacity: loading && data ? 0.6 : 1 } },
    // Header
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 } },
      React.createElement('div', null,
        React.createElement('h1', { style: { fontSize: '1.4rem', fontWeight: 700, color: 'var(--text-hi)', marginBottom: 2 } }, 'Dashboard'),
        React.createElement('p', { style: { fontSize: '0.78rem', color: 'var(--text-lo)' } }, 'Periodo: ', React.createElement('strong', { style: { color: 'var(--accent)' } }, periodLabel))
      ),
      // Period quick filters
      React.createElement('div', { style: { display: 'flex', gap: 4 } },
        ['Hoje', '7 dias', '30 dias', 'Mes'].map(function(label) {
          var isActive = periodLabel === label || (label === 'Mes' && periodLabel === MESES[calMonth]);
          return React.createElement('button', { key: label, onClick: function() {
            if (label === 'Hoje') selectToday();
            else if (label === '7 dias') select7d();
            else if (label === '30 dias') select30d();
            else selectMonth();
          }, style: { padding: '6px 14px', borderRadius: 20, fontSize: '0.72rem', fontWeight: 700, cursor: 'pointer', border: isActive ? 'none' : '1px solid var(--border)', background: isActive ? 'var(--accent)' : 'var(--surface)', color: isActive ? '#fff' : 'var(--text-mid)' } }, label);
        })
      )
    ),

    // ===== CALENDAR + TOP BUYERS =====
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1.3fr 1fr', gap: 16, marginBottom: 20 } },
      // Calendar
      React.createElement('div', { style: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: 16 } },
        // Month nav
        React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 } },
          React.createElement('button', { onClick: prevMonth, style: navBtn }, '<'),
          React.createElement('div', { style: { textAlign: 'center' } },
            React.createElement('div', { style: { fontSize: '1rem', fontWeight: 700, color: 'var(--text-hi)' } }, MESES[calMonth] + ' ' + calYear),
            React.createElement('div', { style: { fontSize: '0.72rem', color: 'var(--accent)', fontWeight: 600 } }, 'Total: R$ ' + calTotal.toFixed(2))
          ),
          React.createElement('button', { onClick: nextMonth, style: navBtn }, '>')
        ),
        // Day headers
        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, marginBottom: 4 } },
          DIAS_SEM.map(function(d) { return React.createElement('div', { key: d, style: { textAlign: 'center', fontSize: '0.62rem', fontWeight: 700, color: 'var(--text-lo)', padding: '3px 0', textTransform: 'uppercase' } }, d); })
        ),
        // Days grid
        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 } },
          calDays.map(function(d, idx) {
            if (!d) return React.createElement('div', { key: 'e' + idx });
            var dd = calData[String(d)];
            var rec = dd ? dd.receita : 0;
            var cnt = dd ? dd.count : 0;
            var isSel = selDay === d;
            return React.createElement('div', { key: d, onClick: function() { clickDay(d); },
              style: { textAlign: 'center', padding: '5px 2px', borderRadius: 6, cursor: 'pointer', minHeight: 42,
                background: isSel ? 'var(--accent)' : dayColor(rec),
                border: isToday(d) ? '2px solid var(--accent)' : '1px solid transparent',
                transition: 'all 0.15s' } },
              React.createElement('div', { style: { fontSize: '0.78rem', fontWeight: isToday(d) || isSel ? 700 : 500, color: isSel ? '#fff' : 'var(--text-hi)' } }, d),
              rec > 0 ? React.createElement('div', { style: { fontSize: '0.52rem', fontWeight: 700, color: isSel ? '#fff' : '#34d399', marginTop: 1 } }, 'R$ ' + (rec >= 1000 ? (rec / 1000).toFixed(1) + 'k' : rec.toFixed(0))) : null,
              cnt > 0 ? React.createElement('div', { style: { fontSize: '0.45rem', color: isSel ? 'rgba(255,255,255,0.7)' : 'var(--text-lo)' } }, cnt + 'x') : null
            );
          })
        )
      ),

      // Top Buyers
      React.createElement('div', { style: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, display: 'flex', flexDirection: 'column' } },
        React.createElement('h3', { style: secTitle }, 'Maiores Compradores'),
        React.createElement('p', { style: { fontSize: '0.7rem', color: 'var(--text-lo)', marginBottom: 12 } }, periodLabel),
        topBuyers.length === 0
          ? React.createElement('div', { style: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-lo)', fontSize: '0.82rem' } }, 'Sem vendas no periodo')
          : React.createElement('div', { style: { flex: 1 } },
              topBuyers.map(function(b, i) {
                return React.createElement('div', { key: i, style: { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid var(--border)' } },
                  React.createElement('span', { style: { width: 24, height: 24, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, flexShrink: 0, background: i === 0 ? '#c9a227' : i === 1 ? '#94a3b8' : i === 2 ? '#b45309' : 'var(--border)', color: i < 3 ? '#fff' : 'var(--text-mid)' } }, i + 1),
                  React.createElement('div', { style: { flex: 1, minWidth: 0 } },
                    React.createElement('div', { style: { fontWeight: 600, color: 'var(--text-hi)', fontSize: '0.82rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'pointer', textDecoration: 'underline', textDecorationColor: 'rgba(139,92,246,0.3)' }, onClick: function(e) { e.stopPropagation(); setDetalheModal({tipo:'cliente',valor:b.nome}); } }, b.nome),
                    React.createElement('div', { style: { fontSize: '0.65rem', color: 'var(--text-lo)' } }, b.compras + (b.compras === 1 ? ' compra' : ' compras'))
                  ),
                  React.createElement('div', { style: { fontWeight: 700, color: '#34d399', fontSize: '0.9rem', flexShrink: 0 } }, 'R$ ' + parseFloat(b.valor).toFixed(2))
                );
              })
            ),
        // Total do periodo
        React.createElement('div', { style: { borderTop: '2px solid var(--border)', paddingTop: 10, marginTop: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
          React.createElement('span', { style: { fontSize: '0.78rem', fontWeight: 600, color: 'var(--text-mid)' } }, 'Faturamento'),
          React.createElement('span', { style: { fontSize: '1.1rem', fontWeight: 700, color: 'var(--accent)' } }, 'R$ ' + parseFloat(k.receita_total || 0).toFixed(2))
        )
      )
    ),

    // ===== KPI Cards Row 1 =====
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 16 } },
      React.createElement('div', { style: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px', cursor: 'pointer' }, onClick: function() { setDetalheModal({tipo:'periodo',valor:{start:dateStart||fmt(new Date(calYear,calMonth,1)),end:dateEnd||fmt(new Date(calYear,calMonth+1,0)),label:periodLabel}}); } },
        React.createElement('div', { style: { fontSize: '0.62rem', fontWeight: 600, color: 'var(--text-lo)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
          React.createElement('span', null, 'Receita Periodo'),
          React.createElement('span', { style: { color: 'var(--accent, #8b5cf6)', fontSize: '0.6rem', fontWeight: 700 } }, 'Ver vendas \u2192')
        ),
        React.createElement('div', { style: { fontSize: '1.3rem', fontWeight: 700, color: '#c9a227', lineHeight: 1.2 } }, 'R$ ' + parseFloat(k.receita_total || 0).toFixed(2)),
        React.createElement('div', { style: { fontSize: '0.68rem', color: 'var(--text-lo)', marginTop: 4 } }, 'Loja: R$ ' + parseFloat(k.receita_pedidos || 0).toFixed(2) + ' | Balcao: R$ ' + parseFloat(k.receita_vendas || 0).toFixed(2))
      ),
      KPI('Pedidos Loja', k.total_pedidos, k.pedidos_pendentes + ' pendentes', '#4a9af5'),
      KPI('Clientes', k.total_clientes, 'cadastrados', '#9b59b6'),
      KPI('Produtos no Site', k.no_site, k.total_produtos + ' total', '#34d399')
    ),
    // KPI Row 2
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 24 } },
      KPI('A Receber (Fiado)', 'R$ ' + parseFloat(k.valor_aberto || 0).toFixed(2), parseInt(k.atrasados) > 0 ? k.atrasados + ' atrasado(s)' : k.total_aberto + ' pendencias', parseInt(k.atrasados) > 0 ? '#fca5a5' : '#c9a227'),
      KPI('Estoque Baixo', parseInt(k.estoque_baixo || 0) + parseInt(k.sem_estoque || 0), (k.sem_estoque || 0) + ' sem estoque', parseInt(k.sem_estoque) > 0 ? '#fca5a5' : '#34d399'),
      KPI('Receita Hoje', 'R$ ' + parseFloat(k.receita_hoje || 0).toFixed(2), '', '#6ee7b7')
    ),

    // ===== Bottom sections =====
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: 20 } },
      // Pedidos recentes
      Section('Pedidos Recentes', 'Ver todos', function() { setPage && setPage('pedidos-loja'); },
        (data.pedidos_recentes || []).length === 0 ? Empty('Sem pedidos no periodo') :
        (data.pedidos_recentes || []).map(function(p) {
          return React.createElement('div', { key: p.id, style: rowStyle, onClick: function() { setPage && setPage('pedidos-loja'); } },
            React.createElement('div', { style: { flex: 1 } },
              React.createElement('div', { style: { fontWeight: 600, color: 'var(--accent)', fontSize: '0.82rem' } }, p.order_number),
              React.createElement('div', { style: { fontSize: '0.75rem', color: 'var(--text-lo)' } }, p.customer_name + ' - ' + p.item_count + ' itens')
            ),
            React.createElement('div', { style: { textAlign: 'right' } },
              React.createElement('div', { style: { fontWeight: 700, color: 'var(--text-hi)', fontSize: '0.85rem' } }, 'R$ ' + parseFloat(p.total).toFixed(2)),
              Badge(p.status)
            )
          );
        })
      ),
      // Pagamentos
      Section('Pagamentos em Aberto', 'Ver todos', function() { setPage && setPage('pagamentos'); },
        (data.pagamentos_pendentes || []).length === 0 ? Empty('Sem pagamentos pendentes') :
        (data.pagamentos_pendentes || []).map(function(p) {
          var resta = parseFloat(p.valor_total) - parseFloat(p.valor_pago);
          return React.createElement('div', { key: p.id, style: rowStyle, onClick: function() { setPage && setPage('pagamentos'); } },
            React.createElement('div', { style: { flex: 1 } },
              React.createElement('div', { style: { fontWeight: 600, color: 'var(--text-hi)', fontSize: '0.82rem' } }, p.cliente_nome),
              React.createElement('div', { style: { fontSize: '0.7rem', color: 'var(--text-lo)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 200 } }, p.descricao || '---')
            ),
            React.createElement('div', { style: { textAlign: 'right' } },
              React.createElement('div', { style: { fontWeight: 700, color: '#fca5a5', fontSize: '0.85rem' } }, 'R$ ' + resta.toFixed(2)),
              Badge(p.status)
            )
          );
        })
      )
    ),
    React.createElement('div', { style: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginTop: 20 } },
      // Estoque
      Section('Alertas de Estoque', 'Ver produtos', function() { setPage && setPage('produtos'); },
        (data.estoque_baixo || []).length === 0 ? Empty('Estoque OK') :
        (data.estoque_baixo || []).map(function(p) {
          return React.createElement('div', { key: p.id, style: Object.assign({}, rowStyle, { gap: 10 }) },
            p.img ? React.createElement('img', { src: p.img, alt: '', style: { width: 30, height: 30, objectFit: 'contain', borderRadius: 4, background: 'var(--bg, #111)', flexShrink: 0 } }) : null,
            React.createElement('div', { style: { flex: 1, fontSize: '0.78rem', color: 'var(--text-hi)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, p.name),
            React.createElement('span', { style: { fontSize: '0.72rem', fontWeight: 700, padding: '2px 8px', borderRadius: 10, color: parseInt(p.stock) === 0 ? '#fca5a5' : '#c9a227', background: parseInt(p.stock) === 0 ? 'rgba(239,68,68,0.1)' : 'rgba(201,162,39,0.1)' } }, parseInt(p.stock) === 0 ? 'Sem estoque' : p.stock + ' un')
          );
        })
      ),
      // Top produtos
      Section('Mais Vendidos', null, null,
        (data.top_produtos || []).length === 0 ? Empty('Sem vendas no periodo') :
        (data.top_produtos || []).map(function(p, i) {
          return React.createElement('div', { key: i, style: rowStyle },
            React.createElement('span', { style: { width: 22, height: 22, borderRadius: '50%', background: 'var(--accent)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, flexShrink: 0 } }, i + 1),
            React.createElement('div', { style: { flex: 1, fontSize: '0.78rem', color: 'var(--text-hi)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, p.product_name),
            React.createElement('div', { style: { textAlign: 'right', fontSize: '0.78rem' } },
              React.createElement('span', { style: { color: 'var(--text-mid)' } }, p.qtd_vendida + 'x '),
              React.createElement('span', { style: { color: '#34d399', fontWeight: 600 } }, 'R$ ' + parseFloat(p.receita).toFixed(2))
            )
          );
        })
      )
    )
  ,
    detalheModal ? React.createElement(DetalheVendas, { tipo: detalheModal.tipo, valor: detalheModal.valor, onClose: function() { setDetalheModal(null); } }) : null);
}

function KPI(label, value, sub, color) {
  return React.createElement('div', { style: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px' } },
    React.createElement('div', { style: { fontSize: '0.62rem', fontWeight: 600, color: 'var(--text-lo)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 } }, label),
    React.createElement('div', { style: { fontSize: '1.3rem', fontWeight: 700, color: color, lineHeight: 1.2 } }, value),
    sub ? React.createElement('div', { style: { fontSize: '0.68rem', color: 'var(--text-lo)', marginTop: 4 } }, sub) : null
  );
}

function Section(title, action, onAction, content) {
  return React.createElement('div', { style: { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, padding: 16 } },
    React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 } },
      React.createElement('h3', { style: secTitle }, title),
      action ? React.createElement('button', { onClick: onAction, style: { background: 'none', border: 'none', color: 'var(--accent)', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer' } }, action + ' ->') : null
    ),
    content
  );
}

function Badge(status) {
  var map = { pendente: ['Pendente', '#c9a227', 'rgba(201,162,39,0.15)'], confirmado: ['Confirmado', '#6ee7b7', 'rgba(37,211,102,0.15)'], enviado: ['Enviado', '#4a9af5', 'rgba(74,154,245,0.15)'], entregue: ['Entregue', '#34d399', 'rgba(37,211,102,0.2)'], cancelado: ['Cancelado', '#fca5a5', 'rgba(239,68,68,0.15)'], parcial: ['Parcial', '#4a9af5', 'rgba(74,154,245,0.15)'], atrasado: ['Atrasado', '#fca5a5', 'rgba(239,68,68,0.15)'], pago: ['Pago', '#34d399', 'rgba(37,211,102,0.2)'] };
  var s = map[status] || map.pendente;
  return React.createElement('span', { style: { padding: '2px 8px', borderRadius: 10, fontSize: '0.58rem', fontWeight: 700, background: s[2], color: s[1] } }, s[0]);
}

function Empty(text) {
  return React.createElement('div', { style: { padding: '1.5rem 0', textAlign: 'center', color: 'var(--text-lo)', fontSize: '0.82rem' } }, text);
}

var secTitle = { fontSize: '0.75rem', fontWeight: 700, color: 'var(--text-mid)', textTransform: 'uppercase', letterSpacing: '0.06em' };
var rowStyle = { display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0', borderBottom: '1px solid var(--border)', cursor: 'pointer' };
var navBtn = { background: 'none', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text-hi)', fontSize: '1.1rem', width: 34, height: 34, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' };
